export const DEPOSIT_INSTRUCTIONS = [
  {
    headerTitle: "Credit/debit card",
    items: [
      "Select **Credit/debit** **card**, then enter your card details (**Name** **on** c**ard,** **Card** **number,** **Expiry** **date** and **CVV**)",
      "Select the currency (if applicable) and enter the amount",
      "Confirm transaction per your bank verification (if applicable)",
      "Once done, go to **Trade now**",
    ],
    ariaControls: "credit-debit-card",
  },
  {
    headerTitle: "Bank transfer",
    items: [
      "Select **Bank** **Transfer**, then your preferred bank option",
      "Select the currency (if applicable) and enter the amount",
      "Review the bank details provided by Pepperstone",
      "Make a bank transfer using our payment details, don't forget to add the reference code",
      "Once done, select **I've** **paid**",
      "Funds will take 3-5 business days to appear in your account",
    ],
    ariaControls: "bank-transfer",
  },
  {
    headerTitle: "ApplePay/ GooglePay",
    items: [
      "Select **[ApplePay/GooglePay]**",
      "Select the currency (if applicable) and enter the amount",
      "Confirm transaction per your  [ApplePay/GooglePay] verification",
      "Once done, go to **Trade** **now**",
    ],
    ariaControls: "applepay-googlepay",
  },
  {
    headerTitle: "Crypto",
    items: [
      "Select **Crypto**",
      "Select the currency (if applicable) and enter the amount",
      "Select your preferred crypto and network",
      "Use the unique generated wallet address and/or QR code (ensure the correct network is selected)",
      "Send the exact amount of crypto to the address provided",
      "Once done, go to **Trade** **now**",
    ],
    ariaControls: "crypto",
  },
  {
    headerTitle: "Skrill",
    items: [
      "Select **Skrill**",
      "Select the currency (if applicable) and enter the amount",
      "Enter your Skrill account email address",
      "Log in to Skrill via the provided form and follow the on-screen items to complete the payment",
      "Once done, go to **Trade** **now**",
    ],
    ariaControls: "skrill",
  },
  {
    headerTitle: "Mpesa",
    items: [
      "Select **Mpesa**",
      "Select the currency (if applicable) and enter the amount",
      "Enter your Mpesa account mobile number",
      "Follow the on-screen items provided by MPesa and enter your PIN to complete the payment",
      "Once done, go to **Trade** **now**",
    ],
    ariaControls: "mpesa",
  },
  {
    headerTitle: "Flutterwave Mobile Money",
    items: [
      "Select **Mobile** **Money**",
      "Select the currency (if applicable) and enter the amount",
      "Follow the on-screen items to complete the payment",
      "Once done, go to **Trade** **now**",
    ],
    ariaControls: "flutterwave-mobile-money",
  },
  {
    headerTitle: "SPEI",
    items: [
      "Select **SPEI**",
      "Select the currency (if applicable) and enter the amount",
      "Enter your details (**CLABE**, **Bank** **name**)",
      "Review the SPEI transfer details provided by Pepperstone",
      "Make a SPEI transfer using the payment details, don't forget to use the payment code",
      "Once done, select **I've** **paid**",
    ],
    ariaControls: "spei",
  },
  {
    headerTitle: "PIX",
    items: [
      "Select PIX",
      "Select the currency (if applicable) and enter the amount",
      "Enter your details (**CPF** **number**)",
      "Review the PIX transfer details provided by Pepperstone and scan the QR code with your bank's app",
      "Once done, select **I've** **paid**",
    ],
    ariaControls: "pix",
  },
  {
    headerTitle: "UnionPay",
    items: [
      "Select **UnionPay**",
      "Select the currency (if applicable) and enter the amount",
      "Enter your details (**Account** **name**, **Account** **number**, **Bank** **name**, **Branch** **name**)",
      "Review the UnionPay transfer details provided by Pepperstone and complete the transaction",
      "Once done, select **I've** **paid**",
    ],
    ariaControls: "unionpay",
  },
  {
    headerTitle: "ChipPay",
    items: [
      "Select **ChipPay**",
      "Select the currency (if applicable) and enter the amount",
      "You will be redirected to a third-party website where you'll need to enter your details and possibly go through a KYC verification process",
      "Select your desired payment option/method",
      "Review the ChipPay transfer details provided and complete the transaction",
      "Once the transfer is completed, Select **Return** **to** **merchant**",
      "Once done, select **I've** **paid**",
    ],
    ariaControls: "chippay",
  },
  {
    headerTitle: "WalaoPay",
    items: [
      "Select **WalaoPay**",
      "Select the currency (if applicable) and enter the amount",
      "You will be redirected to a third-party website where you'll need to enter your details and possibly go through a KYC verification process",
      "Select your desired payment option/method",
      "Review the WalaoPay transfer details provided and complete the transaction",
      "Once the transfer is completed, select **Return** **to** **merchant**",
      "Once done, select **I've** **paid**",
    ],
    ariaControls: "walaopay",
  },
  {
    headerTitle: "ZotaPay",
    items: [
      "Select **ZotaPay**",
      "Select the currency (if applicable) and enter the amount",
      "You will be redirected to a third-party website where you'll need to enter your details and possibly go through a KYC verification process",
      "Select your desired payment option/method",
      "Review the **ZotaPay** transfer details provided and complete the transaction",
      "Once the transfer is completed, select **Return** **to** **merchant**",
      "Once done, select **I've** **paid**",
    ],
    ariaControls: "zotapay",
  },
  {
    headerTitle: "XPay",
    items: [
      "Select **XPay**",
      "Select the currency (if applicable) and enter the amount",
      "You will be redirected to a third-party website where you'll need to enter your details and possibly go through a KYC verification process",
      "Select your desired payment option/method",
      "Review the **XPay** transfer details provided and complete the transaction",
      "Once the transfer is completed, select **Return** **to** **merchant**",
      "Once done, select **I've** **paid**",
    ],
    ariaControls: "xpay",
  },
  {
    headerTitle: "Neteller",
    items: [
      "Select **Neteller** and enter your **Neteller** **email** **address** (or select one that was already used)",
      "Enter the deposit amount and click **Next**",
      "You'll be redirected to Neteller — log in and complete the payment",
    ],
    ariaControls: "neteller",
  },
];

export const WITHDRAW_INSTRUCTIONS = [
  "Select the account you’d like to withdraw, and **tap** **Withdrawal**",
  "You must first withdraw the **Refundable** **amount** before being able to withdraw your profits",
  "Once your refund is processed, select the payment method you wish to withdraw your **Profit** through",
  "Select your preferred method for taking profits based on your region and account verification",
  "Enter your withdrawal details",
  "Review the withdrawal information then **Confirm** to continue",
  "Verify the withdrawal to approve the transaction",
  "Once your withdrawal request has been successfully submitted, track the status from your **History**",
];
